import { useState } from "react";
import { Box, Button, CssBaseline, Dialog, DialogContent, DialogTitle, Grid, IconButton, Typography } from "@mui/material";
import MetaDecorator from "../services/meta_decorator";
import { Navigate } from "react-router-dom";
import { bodyBg, footerContainer, fullHeight, headerText, orangecolor, rcolor, registrationHeader, whitecolor } from "../style2";
import { DerbyshireOrgCode } from "../services/utility";
import Footer from "../components/shared/footer";

import LoginIcon from '@mui/icons-material/Login';

export default function ReferralDefault() {
  const [redirect, setRedirect] = useState('');
  const [openDialog, setOpenDialog] = useState(false);

  const trusts = [
    {
      name: "Derbyshire Healthcare Trust (DHCFT)",
      services: [
        "Children’s Neurodevelopmental care pathway",
      ],
      code: DerbyshireOrgCode,
      enabled: true
    },
    {
      name: "Homerton NHS Foundation Trust",
      services: [
        "CCC Pathway",
        "Over 5s Single Point of Access"
      ],
      code: "",
      enabled: false
    }
  ];
  if (redirect !== "")
    return <Navigate to={redirect} />;
  else
    return <Box sx={{ ...bodyBg, ...fullHeight }}>
      <CssBaseline />
      <MetaDecorator title={"EnrichMyCare - Referral"} description={"EnrichMycare Refferal"} />
      <Box sx={{ background: whitecolor, padding: 1, height: "100vh" }}>
        <Grid container sx={{ flexGrow: 1 }} spacing={0}>
          <Grid item size={6}>
            <Box component="img" sx={registrationHeader} src='../logo.jpg' alt='EnrichMyCare Logo' />
          </Grid>
          <Grid item size={6} sx={{ textAlign: "right" }} >
            <Box sx={{ paddingTop: 1 }}>
              <Typography component="span" sx={{ fontSize: '1.1rem', verticalAlign: 'middle' }}>
                Returning User?{' '}
                <IconButton sx={{ mr: 1, ml: 1 }}
                  onClick={() => setRedirect(`/login/${DerbyshireOrgCode}`)}
                >
                  <LoginIcon sx={{ fontSize: "3.5rem", color: rcolor }} />
                </IconButton>
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <Box>
          <Typography variant="h3" sx={{ ...headerText, padding: "5rem 10rem", fontSize: "3rem", fontWeight: "bold", lineHeight: 1.5, textAlign: "center" }}>
            Welcome to EnrichMyCare AI – driven referral and triage platform
          </Typography>
        </Box>
        <Box textAlign="center">
          <Button onClick={() => { setOpenDialog(true) }}
            style={{ background: orangecolor, borderRadius: 15, padding: "1rem 2rem", color: whitecolor, textTransform: "capitalize", fontSize: "1.3rem" }}>
            START YOUR REFERRAL
          </Button>
        </Box>
      </Box>
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle sx={{ ...headerText, color: orangecolor }}>Select Trust and Service</DialogTitle>
        <DialogContent>
          {trusts.map((trust, idx) => (
            <Box key={trust.name} sx={{ mb: 2 }}>
              <Button
                disabled={!trust.enabled}
                variant="outlined"
                sx={{ ...headerText, width: '100%', justifyContent: 'flex-start', textAlign: 'left', fontSize: '1.2rem', p: 2, mb: 1 }}
                onClick={() => {
                  setRedirect(`/information/${trust.code}`);
                  setOpenDialog(false);
                }}
              >
                {trust.name}
              </Button>
            </Box>
          ))}
        </DialogContent>
      </Dialog>
      <Box sx={footerContainer}>
        <Footer />
      </Box>
    </Box>;
}